import * as React from 'react';
import * as R from 'ramda';
import { Form, Text, FormValues, FormErrors } from 'react-form';
import { BaseFormProps, BaseFormState } from '../../interfaces';
import { ValidationService } from '../../services';

export class LanguageForm extends React.Component<BaseFormProps, BaseFormState> {
    private vs = new ValidationService();

    constructor(props: BaseFormProps) {
        super(props);

        this.state = {
            canSubmit: false,
            formErrors: {}
        };

        this.validateErrors = this.validateErrors.bind(this);
        this.validateSuccess = this.validateSuccess.bind(this);
    }

    // Validation methods
    validateErrors(values: FormValues) {
        const { name, code } = values;
        let formErrors: any = {};

        if (name || name === '') {
            if (!this.vs.required(name)) {
                formErrors.name = 'Name is required.';
            } else if (!this.vs.cannotBeEmpty(name!)) {
                formErrors.name = 'Name cannot be blank.';
            }
        }

        if (code || code === '') {
            if (!this.vs.required(code)) {
                formErrors.code = 'Code is required.';
            } else if (!this.vs.cannotBeEmpty(code!)) {
                formErrors.code = 'Code cannot be blank.';
            }
        }

        return formErrors;
    }

    validateSuccess(values: FormValues, errors: FormErrors) {
        // make sure we have no errors and all the required values
        if (R.isEmpty(errors) && this.vs.validateRequiredFieldsExist(['name', 'code'], values)) {
            this.setState({ canSubmit: true, formErrors: errors });
        } else {
            this.setState({ canSubmit: false, formErrors: errors });
        }

        return errors;
    }
    // end of validation stuff

    public render() {
        const { canSubmit, formErrors } = this.state;
        return (
            <Form
                defaultValues={this.props.defaultValues}
                onSubmit={submittedValues => this.props.submit(submittedValues)}
                validateError={this.validateErrors}
                validateSuccess={this.validateSuccess}
            >
                {formApi => (
                    <form onSubmit={formApi.submitForm} id="entityForm">
                        <div className="form-group">
                            <label htmlFor="name">Name *</label>
                            <Text className="form-control" field="name" id="name" />
                            {formErrors.name && <span className="help-block error-text">{formErrors.name}</span>}
                        </div>
                        <div className="form-group">
                            <label htmlFor="code">ISO Language Code *</label>
                            <Text className="form-control" field="code" id="code" placeholder="e.g. en-US for U.S. English" />
                            {formErrors.code && <span className="help-block error-text">{formErrors.code}</span>}
                        </div>

                        <button type="submit" className="btn btn-primary" disabled={!canSubmit}>Save</button>
                    </form>
                )}
            </Form>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/language/LanguageForm.tsx